module.exports = __webpack_public_path__ + "static/media/icon-arrow.d296ff3a.svg";